import React from 'react';

interface DisplacementSliderProps {
  options: string[];
  value: number;
  onChange: (value: number) => void;
}

const DisplacementSlider: React.FC<DisplacementSliderProps> = ({
  options,
  value,
  onChange,
}) => {
  const handleButtonClick = (index: number) => {
    onChange(index);
  };

  return (
    <div className="displacement-button-container">
      {options.map((label, index) => (
        <button
          key={label}
          className={`displacement-button${index === value ? ' active' : ''}`}
          onClick={() => handleButtonClick(index)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default DisplacementSlider;
